import { APP_VERSION } from '../../services/feedback';
import AndroidApp from './AndroidApp';

/** Whether this browser is on an Android phone or tablet, where the Android app can be installed. */
const onAndroid = (userAgent: string = navigator.userAgent) => /Android/i.test(userAgent);

/**
 * Settings > About: the website's own version, which every browser runs and
 * which updates itself (a reload gets the newest). Only a browser on Android
 * is offered the Android app as well; on an iPhone or a computer it would be
 * a file nobody there can install (Chris, 2026-10-06).
 */
export default function AboutApp() {
  return (
    <div className="space-y-4">
      <p className="text-sm text-on-surface-variant">
        Cerebro Diem on the web, version <span className="font-mono">{APP_VERSION}</span>. The website updates itself: reload the page
        to get the newest.
      </p>
      {onAndroid() && (
        <div className="space-y-2">
          <h3 className="font-medium">Android app</h3>
          <AndroidApp />
        </div>
      )}
    </div>
  );
}
